<ion-item class="qvs-no-internet-connection" lines="none">
  <qvs-svg-icon
    class="qvs-no-internet-connection__icon"
    [src]="'/assets/icon/No_Internet_Connection.svg'"
    [title]="'no-internet-connection-icon'"
  ></qvs-svg-icon>
  <ion-label class="qvs-no-internet-connection__label">
    <h3 class="qvs-no-internet-connection__label__title">
      {{ 'no-internet-connection.INTERNET_CONNECTION_LOST_TITLE' | translate }}
    </h3>
    <p class="qvs-no-internet-connection__label__description">
      {{ 'no-internet-connection.INTERNET_CONNECTION_LOST_DESCRIPTION' | translate }}
    </p>
  </ion-label>
  <qvs-svg-icon
    class="qvs-no-internet-connection__close-icon"
    [src]="'/assets/images/close.svg'"
    [title]="'close-icon'"
    (click)="closeIndicator.emit()"
  ></qvs-svg-icon>
</ion-item>
